import easydropdown from 'easydropdown'

export class LanguageSwitcher extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.init()
  }

  init() {
    const selectElement = this.querySelector('.pll-switcher-select')
    if (selectElement) {
      easydropdown(selectElement)
    }
  }
}
